export const ERRORS_TITLE = "ERRORS_ALERTS_TITLE";

export const ERRORS_ALERTS_CONNECTOR = "ERRORS_ALERTS_CONNECTOR";
export const ERRORS_ALERTS_APPLICATION_TIMEOUT = "ERRORS_ALERTS_APPLICATION_TIMEOUT";
export const ERRORS_ALERTS_TIMEOUT = "ERRORS_ALERTS_TIMEOUT";
export const ERRORS_ALERTS_SESSION_TIMEOUT = "ERRORS_ALERTS_SESSION_TIMEOUT";
export const ERRORS_ALERTS_PARAMETERS = "ERRORS_ALERTS_PARAMETERS";
export const ERRORS_ALERTS_UNKNOWN = "ERRORS_ALERTS_UNKNOWN";
export const ERRORS_ALERTS_UNKNOWN_PAYMENT_TYPE = "ERRORS_ALERTS_UNKNOWN_PAYMENT_TYPE";
export const ERRORS_ALERTS_UNSUPPORTED_PAYMENT_TYPE = "ERRORS_ALERTS_UNSUPPORTED_PAYMENT_TYPE";
export const ERRORS_ALERTS_NO_SUPPORTED_PAYMENT_TYPE = "ERRORS_ALERTS_NO_SUPPORTED_PAYMENT_TYPE";
export const ERRORS_ALERTS_PRIVILEGES = "ERRORS_ALERTS_PRIVILEGES";
export const ERRORS_ALERTS_USAGE = "ERRORS_ALERTS_USAGE";
export const ERRORS_ALERTS_FORBIDDEN_CARD = "ERRORS_ALERTS_FORBIDDEN_CARD";
export const ERRORS_ALERTS_DOMAIN = "ERRORS_ALERTS_DOMAIN";
export const ERRORS_ALERTS_TOKEN_FAILED = "ERRORS_ALERTS_TOKEN_FAILED";
export const ERRORS_ALERTS_TOKEN_CVV_AUTHORIZATION_FAILED = "ERRORS_ALERTS_TOKEN_CVV_AUTHORIZATION_FAILED";
export const ERRORS_ALERTS_THREE_DS_FAILED = "ERRORS_ALERTS_THREE_DS_FAILED";
export const ERRORS_ALERTS_UNSUPPORTED_CARD_INSTALLMENT = "ERRORS_ALERTS_UNSUPPORTED_CARD_INSTALLMENT";

export enum PatchedResponseCode {
    ERRORS_ALERTS_SERVICE_UNAVAILABLE = "errors_alerts_service_unavailable",
    ERRORS_ALERTS_SERVICE_UNAVAILABLE_INFO = "errors_alerts_service_unavailable_info",
    ERRORS_ALERTS_CAPTURE_CREDIT_ONLY = "errors_alerts_capture_credit_only",
    ERROR_ALERTS_PAIDY_PAYMENT_REJECTED = "error_alerts_paidy_payment_rejected",
    EMAIL_EXISTS_FOR_CARD = "email_exists_for_card",
    SERVICE_RESTRICTED = "service_restricted",
    EXPIRATION_DATE_ERROR = "expiration_date_error",
    NO_GATEWAY_AVAILABLE_TO_PROCESS_REQUEST = "no_gateway_available_to_process_request",
    COUNTRY_NOT_ALLOWED = "country_not_allowed",
}

export { ERROR_CHECKOUT_CHARGE } from "../../errors/ChargeError";
export { ERROR_CHECKOUT_SUBSCRIPTION } from "../../errors/SubscriptionError";
export { ERROR_CHECKOUT_PARAMS } from "../../errors/CheckoutParametersError";
